import React from 'react';
import Box from '@components/Atoms/Box';
import { IconButton, ListItemText, MenuItem, Tooltip } from '@mui/material';
import CompareIcon from '@mui/icons-material/Compare';
import EditIcon from '@mui/icons-material/Edit';
import StarsIcon from '@mui/icons-material/Stars';
import ShowIf from '@components/Atoms/ShowIf';
import { STATE } from './SlideControls';

interface SavedMenuItemProps {
  state: string;
  onMenuClick: () => void;
  handleEdit: () => void;
  handleCompare: () => void;
}

const SavedMenuItem: React.FC<SavedMenuItemProps> = ({
  state,
  onMenuClick,
  handleEdit,
  handleCompare,
}) => (
  <MenuItem onClick={onMenuClick}>
    <StarsIcon sx={{ mr: 1 }} />
    <ListItemText
      primary="My Version (Saved)"
      secondary={
        state === STATE.SAVED
          ? "'Edit' creates a new draft. Keeping this unaffected."
          : 'Saving the draft below will overwrite this version.'
      }
      secondaryTypographyProps={{
        variant: 'caption',
        color: 'text.secondary',
        fontSize: '0.75rem',
      }}
    />
    <Box sx={{ display: 'flex', gap: '0.25rem', ml: '1rem' }}>
      <ShowIf If={state === STATE.SAVED}>
        <Tooltip title="Edit">
          <IconButton
            size="small"
            onClick={() => handleEdit()}
            aria-label="Edit"
            sx={{
              backgroundColor: 'primary.main',
              color: 'white',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </ShowIf>
      <Tooltip title="Compare with the slide above">
        <IconButton
          size="small"
          onClick={() => handleCompare()}
          aria-label="Compare"
          sx={{
            backgroundColor: 'info.main',
            color: 'white',
            '&:hover': {
              backgroundColor: 'info.dark',
            },
          }}
        >
          <CompareIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  </MenuItem>
);

export default SavedMenuItem;
